
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faQuestionCircle, 
  faChevronDown
} from "@fortawesome/free-solid-svg-icons";

const FAQ_DATA = [
  {
    question: "What is Shop Kiganjani?",
    answer:
      "Shop Kiganjani is a shop management platform that helps small and medium business owners track sales, manage inventory, separate capital from profit, and access real-time financial reports -- all from one easy-to-use dashboard.",
  },
  {
    question: "Do I need any technical skills to use it?",
    answer:
      "Not at all. Shop Kiganjani is designed for everyday shop owners. If you can use a smartphone, you can use our platform. The interface is simple, intuitive, and available in both English and Swahili.",
  },
  {
    question: "How does it help prevent stock loss?",
    answer:
      "Every product entry, sale, and stock movement is recorded in real-time. The system flags discrepancies between expected and actual stock levels, helping you detect unrecorded sales or potential theft immediately.",
  },
  {
    question: "Can I track my profit and loss in real-time?",
    answer:
      "Yes. Shop Kiganjani provides instant profit and loss summaries on a daily, weekly, monthly, and annual basis. You no longer need to wait for end-of-month calculations.",
  },
  {
    question: "What is the difference between capital and profit tracking?",
    answer:
      "Many shop owners accidentally mix their initial investment (capital) with earnings (profit). Our system tracks them separately so you always know your true profit and never dip into your capital unknowingly.",
  },
  {
    question: "Is my business data secure?",
    answer:
      "Absolutely. All data is encrypted and stored securely. Only authorized users with proper credentials can access your business information.",
  },
  {
    question: "Can I manage multiple staff members?",
    answer:
      "Yes. You can assign staff to your shop, track their activity status (active or suspended), and manage roles -- all from the staffing module in your dashboard.",
  },
];

export function FaqSection() {
  const [openFaq, setOpenFaq] = useState(0);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <section className="py-16 px-6 bg-gray-200">
      <div className="max-w-8xl mx-auto">
        
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 border border-blue-500 bg-white text-blue-600 text-base font-bold px-4 py-1 rounded-full mb-4 shadow-sm">
            <FontAwesomeIcon icon={faQuestionCircle} className="text-blue-500 text-lg md:text-xl" />
            <span className="inline-block">FAQ</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-gray-800 mb-3">
            Frequently Asked{' '}
            <span className="text-orange-500">Questions</span>
          </h2>
          <p className="text-gray-700 text-lg md:text-xl max-w-2xl mx-auto">
            Everything you need to know about Shop Kiganjani and how it can help your business grow
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="w-full max-w-4xl mx-auto">
          {FAQ_DATA.map((faq, index) => (
            <div key={index} className="border-b-2 border-gray-400 transition-all duration-300">
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex justify-between items-center py-5 text-left bg-transparent hover:bg-blue-50/50 transition-all duration-300 px-4 rounded-lg group"
              >
                <div className="flex items-center gap-3">
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 font-bold text-sm ${
                    openFaq === index 
                      ? 'bg-blue-500 text-white' 
                      : 'bg-orange-100 text-orange-600 group-hover:bg-orange-200'
                  }`}>
                    {index + 1}
                  </div>
                  <span className={`font-semibold text-md md:text-xl transition-all duration-300 ${
                    openFaq === index ? 'text-blue-600' : 'text-gray-800 group-hover:text-blue-500'
                  }`}>
                    {faq.question}
                  </span>
                </div>
                <FontAwesomeIcon
                  icon={faChevronDown}
                  className={`text-gray-700 text-md md:text-xl transition-all duration-300 ${
                    openFaq === index ? 'rotate-180 text-blue-500' : 'group-hover:text-orange-500'
                  }`}
                />
              </button>
              
              {/* Answer */}
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  openFaq === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-4 pb-5 pl-14">
                  <p className="text-gray-600 text-md md:text-xl leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}